import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      d="M4.117 7.11a.417.417 0 0 1 .562 0L10 12.1l5.32-4.99a.417.417 0 0 1 .563 0 .357.357 0 0 1 0 .527l-5.602 5.254A.4.4 0 0 1 10 13a.4.4 0 0 1-.281-.11L4.117 7.638a.357.357 0 0 1 0-.528"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChevronDown;
